<div class="iflx-widget-body AT_widget_offlineBookings">
  <offline-bookings-widget has-perm="hasPerm" goto-terminal="gotoTerminal" />
</div>
